// extracted by mini-css-extract-plugin
module.exports = {"review":"hN","value":"hO","name":"hP","isRental":"hQ"};